module.exports = __webpack_public_path__ + "static/media/logo.f354d86d.png";